/* assets/mc-product-scripts.js
   MC Produktseite: H1 umhaengen, Galerie Thumbs, Zoom, Beschreibung Features (H1->H2, TOC, Links, GA4)
*/
(function () {
  "use strict";

  function qs(root, sel) {
    return root ? root.querySelector(sel) : null;
  }
  function qsa(root, sel) {
    return root ? Array.prototype.slice.call(root.querySelectorAll(sel)) : [];
  }

  function toBool(val) {
    if (val === true || val === false) return val;
    if (val == null) return false;
    var s = String(val).toLowerCase().trim();
    return s === "true" || s === "1" || s === "yes";
  }

  function slugify(text) {
    return String(text || "")
      .toLowerCase()
      .trim()
      .replace(/&/g, " und ")
      .replace(/[^a-z0-9\u00c0-\u017f\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function isExternalUrl(href) {
    if (!href) return false;
    var h = String(href).trim();
    if (h.indexOf("#") === 0) return false;
    if (h.indexOf("mailto:") === 0) return false;
    if (h.indexOf("tel:") === 0) return false;

    if (h.indexOf("http://") !== 0 && h.indexOf("https://") !== 0) return false;

    try {
      var u = new URL(h, window.location.href);
      return u.hostname && u.hostname !== window.location.hostname;
    } catch (e) {
      return false;
    }
  }

  function uniqueId(base, used) {
    var id = base || "abschnitt";
    var i = 2;

    while (used[id] || (document.getElementById(id) && used[id] !== "__same__")) {
      id = (base || "abschnitt") + "-" + i;
      i++;
    }
    used[id] = true;
    return id;
  }

  function getFixedScrollOffset() {
    return 90;
  }

  function smoothScrollToElement(el) {
    if (!el) return;

    var rect = el.getBoundingClientRect();
    var y = rect.top + window.pageYOffset - getFixedScrollOffset();
    window.scrollTo({ top: Math.max(0, y), behavior: "smooth" });

    try {
      el.setAttribute("tabindex", "-1");
      el.focus({ preventScroll: true });
      setTimeout(function () {
        el.removeAttribute("tabindex");
      }, 400);
    } catch (e) {}
  }

  /* ---------------------------
     H1 umhaengen (Desktop/Mobil)
  ---------------------------- */
  function initH1Relocation(scopeEl) {
    var sectionId = scopeEl.getAttribute("data-mc-product-scope");
    if (!sectionId) return;

    var desktopTarget = qs(scopeEl, '[data-mc-h1-target="desktop"]');
    var mobileTarget = qs(scopeEl, '[data-mc-h1-target="mobile"]');

    if (!desktopTarget || !mobileTarget) return;

    var headerEl =
      qs(scopeEl, ".mc-product-header-group") ||
      qs(scopeEl, ".mc-product-title") ||
      qs(desktopTarget, ".mc-product-title") ||
      qs(mobileTarget, ".mc-product-title");

    if (!headerEl) return;

    var mql = window.matchMedia("(max-width: 749px)");

    function placeTitle() {
      var shouldBeMobile = !!mql.matches;
      var currentParent = headerEl.parentNode;

      if (shouldBeMobile) {
        if (currentParent !== mobileTarget) mobileTarget.appendChild(headerEl);
      } else {
        if (currentParent !== desktopTarget) desktopTarget.appendChild(headerEl);
      }
    }

    placeTitle();

    if (typeof mql.addEventListener === "function") {
      mql.addEventListener("change", placeTitle);
    } else if (typeof mql.addListener === "function") {
      mql.addListener(placeTitle);
    }
  }

  /* ---------------------------
     Galerie: Thumbs -> Main Swap
  ---------------------------- */
  function setGalleryActive(galleryEl, mediaId) {
    if (!galleryEl || !mediaId) return;

    var items = qsa(galleryEl, ".mc-gallery-main-item");
    var thumbs = qsa(galleryEl, ".mc-gallery-thumb");

    items.forEach(function (it) {
      var id = it.getAttribute("data-media-id");
      var isActive = String(id) === String(mediaId);
      it.hidden = !isActive;
      if (isActive) it.classList.add("is-active");
      else it.classList.remove("is-active");
    });

    thumbs.forEach(function (btn) {
      var id = btn.getAttribute("data-media-id");
      var isActive = String(id) === String(mediaId);
      if (isActive) btn.classList.add("is-active");
      else btn.classList.remove("is-active");
      btn.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  }

  function initGallery(scopeEl) {
    qsa(scopeEl, ".mc-gallery").forEach(function (galleryEl) {
      if (galleryEl.getAttribute("data-mc-gallery-init") === "1") return;
      galleryEl.setAttribute("data-mc-gallery-init", "1");

      qsa(galleryEl, ".mc-gallery-thumb").forEach(function (btn) {
        if (!btn.hasAttribute("aria-pressed")) btn.setAttribute("aria-pressed", "false");
      });

      galleryEl.addEventListener("click", function (e) {
        var btn = e.target && e.target.closest ? e.target.closest(".mc-gallery-thumb") : null;
        if (!btn || !galleryEl.contains(btn)) return;

        var mediaId = btn.getAttribute("data-media-id");
        if (!mediaId) return;

        e.preventDefault();
        setGalleryActive(galleryEl, mediaId);
      });

      var firstItem = qs(galleryEl, ".mc-gallery-main-item.is-active") || qs(galleryEl, ".mc-gallery-main-item");
      if (firstItem) {
        var mid = firstItem.getAttribute("data-media-id");
        if (mid) setGalleryActive(galleryEl, mid);
      }
    });
  }

  /* ---------------------------
     Zoom Overlay
  ---------------------------- */
  function closeZoomOverlay(overlay) {
    if (!overlay) return;
    overlay.classList.add("is-closing");
    setTimeout(function () {
      if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
    }, 0);
  }

  function openZoomOverlay(imgEl) {
    if (!imgEl) return;

    var isSvgArtwork = imgEl.tagName && imgEl.tagName.toLowerCase() === "svg";
    var src = isSvgArtwork ? "" : (imgEl.currentSrc || imgEl.getAttribute("src"));
    if (!src && !isSvgArtwork) return;

    var localizedZoomSrc = isSvgArtwork ? "" : imgEl.getAttribute("data-mc-zoom-full");
    var hiSrc = localizedZoomSrc || src;
    try {
      if (!localizedZoomSrc) hiSrc = src.replace(/width=\d+/g, "width=2000");
    } catch (e) {}

    var overlay = document.createElement("div");
    overlay.className = "mc-zoom-overlay";
    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");

    var inner = document.createElement("div");
    inner.className = "mc-zoom-overlay__inner";

    if (isSvgArtwork) {
      // Preserve the Dutch SVG text layer in image zoom, rather than opening
      // an untranslated German raster source.
      var zoomSvg = imgEl.cloneNode(true);
      zoomSvg.classList.remove("mc-gallery-main-image");
      zoomSvg.style.width = "min(92vw, 1500px)";
      zoomSvg.style.maxWidth = "100%";
      zoomSvg.style.height = "auto";
      inner.appendChild(zoomSvg);
    } else {
      var big = document.createElement("img");
      big.alt = imgEl.getAttribute("alt") || "";
      big.src = hiSrc;
      inner.appendChild(big);
    }
    overlay.appendChild(inner);
    document.body.appendChild(overlay);

    function onKey(e) {
      if (e.key === "Escape") {
        document.removeEventListener("keydown", onKey);
        closeZoomOverlay(overlay);
      }
    }
    document.addEventListener("keydown", onKey);

    overlay.addEventListener("click", function () {
      document.removeEventListener("keydown", onKey);
      closeZoomOverlay(overlay);
    });

    inner.addEventListener("click", function (e) {
      e.stopPropagation();
    });
  }

  function initZoom(scopeEl) {
    qsa(scopeEl, ".mc-gallery").forEach(function (galleryEl) {
      var hasZoom = toBool(galleryEl.getAttribute("data-has-zoom"));
      if (!hasZoom) return;

      galleryEl.addEventListener("click", function (e) {
        var img = e.target && e.target.closest ? e.target.closest(".mc-gallery-main-image") : null;
        if (!img || !galleryEl.contains(img)) return;

        e.preventDefault();
        openZoomOverlay(img);
      });
    });
  }

  /* ---------------------------
     Beschreibung: H1->H2, TOC, Links, GA4, Lazy
  ---------------------------- */
  function convertRteH1ToH2(contentEl) {
    if (!contentEl) return;
    var h1s = qsa(contentEl, "h1");
    if (!h1s.length) return;

    h1s.forEach(function (h1) {
      var h2 = document.createElement("h2");
      for (var i = 0; i < h1.attributes.length; i++) {
        var a = h1.attributes[i];
        if (a && a.name) h2.setAttribute(a.name, a.value);
      }
      h2.innerHTML = h1.innerHTML;
      h1.parentNode.replaceChild(h2, h1);
    });
  }

  function applyLazyLoading(contentEl) {
    if (!contentEl) return;
    qsa(contentEl, "img").forEach(function (img) {
      if (!img.getAttribute("loading")) img.setAttribute("loading", "lazy");
      if (!img.getAttribute("decoding")) img.setAttribute("decoding", "async");
    });
  }

  function optimizeExternalLinks(contentEl, relValue, addNoFollow) {
    if (!contentEl) return;

    var rel = String(relValue || "").trim();
    var nofollow = !!addNoFollow;

    qsa(contentEl, "a[href]").forEach(function (a) {
      var href = a.getAttribute("href");
      if (!isExternalUrl(href)) return;

      a.setAttribute("target", "_blank");

      var finalRel = rel;
      if (nofollow) {
        if (finalRel) {
          if (finalRel.indexOf("nofollow") === -1) finalRel = finalRel + " nofollow";
        } else {
          finalRel = "nofollow";
        }
      }
      if (finalRel) a.setAttribute("rel", finalRel);
    });
  }

  function buildToc(wrapperEl, contentEl) {
    if (!wrapperEl || !contentEl) return;

    var tocWrap = qs(wrapperEl, ".product-description-mc__toc");
    var tocBtn = qs(wrapperEl, ".product-description-mc__toc-toggle");
    var tocList = qs(wrapperEl, ".product-description-mc__toc-list");
    if (!tocWrap || !tocBtn || !tocList) return;

    var headings = qsa(contentEl, "h2, h3, h4, h5, h6").filter(function (h) {
      return String(h.textContent || "").trim().length > 0;
    });

    if (!headings.length) {
      tocWrap.style.display = "none";
      return;
    }

    if (!tocList.id) {
      tocList.id = "mc-toc-" + Math.random().toString(36).slice(2);
    }
    tocBtn.setAttribute("aria-controls", tocList.id);

    var used = {};
    headings.forEach(function (h) {
      var existing = h.getAttribute("id");
      if (existing) {
        used[existing] = "__same__";
        return;
      }
      var base = slugify(h.textContent) || "abschnitt";
      h.setAttribute("id", uniqueId(base, used));
    });

    tocList.innerHTML = "";

    headings.forEach(function (h) {
      var level = 2;
      if (h.tagName === "H3") level = 3;
      if (h.tagName === "H4") level = 4;
      if (h.tagName === "H5") level = 5;
      if (h.tagName === "H6") level = 6;

      var li = document.createElement("li");
      li.className = "mc-toc-item mc-toc-lvl-" + level;

      var a = document.createElement("a");
      var id = h.getAttribute("id");
      a.href = "#" + id;
      a.textContent = String(h.textContent || "").trim();

      a.addEventListener("click", function (e) {
        e.preventDefault();
        var target = document.getElementById(id);
        if (!target) return;

        tocBtn.setAttribute("aria-expanded", "true");
        tocList.removeAttribute("hidden");

        smoothScrollToElement(target);
        try {
          history.replaceState(null, "", "#" + id);
        } catch (err) {}
      });

      li.appendChild(a);
      tocList.appendChild(li);
    });

    function setExpanded(expanded) {
      tocBtn.setAttribute("aria-expanded", expanded ? "true" : "false");
      if (expanded) tocList.removeAttribute("hidden");
      else tocList.setAttribute("hidden", "hidden");
    }

    setExpanded(false);

    tocBtn.addEventListener("click", function () {
      var isOpen = tocBtn.getAttribute("aria-expanded") === "true";
      setExpanded(!isOpen);
    });
  }

  function initBackToTop(wrapperEl) {
    if (!wrapperEl) return;
    var anchorSel = wrapperEl.getAttribute("data-back-to-top-anchor");
    if (!anchorSel) return;

    qsa(wrapperEl, 'a[href^="#"]').forEach(function (a) {
      var href = a.getAttribute("href");
      if (!href) return;

      if (href !== anchorSel && ("#" + href.replace(/^#/, "")) !== anchorSel) return;

      a.addEventListener("click", function (e) {
        var targetId = String(anchorSel).replace(/^#/, "");
        var target = document.getElementById(targetId);
        if (!target) return;
        e.preventDefault();
        smoothScrollToElement(target);
      });
    });
  }

  function initGA4LinkTracking(wrapperEl, contentEl, sectionId) {
    if (!wrapperEl || !contentEl) return;

    contentEl.addEventListener("click", function (e) {
      var a = e.target && e.target.closest ? e.target.closest("a[href]") : null;
      if (!a || !contentEl.contains(a)) return;

      var href = a.getAttribute("href") || "";
      var text = String(a.textContent || "").trim().slice(0, 120);

      var payload = {
        link_url: href,
        link_text: text,
        section_id: sectionId || "",
        component: "mc_product_description"
      };

      if (typeof window.gtag === "function") {
        window.gtag("event", "mc_description_link_click", payload);
        return;
      }

      if (window.dataLayer && typeof window.dataLayer.push === "function") {
        window.dataLayer.push(
          Object.assign(
            {
              event: "mc_description_link_click"
            },
            payload
          )
        );
      }
    });
  }

  function initDescription(scopeEl) {
    var sectionId = scopeEl.getAttribute("data-mc-product-scope") || "";

    qsa(scopeEl, "[data-mc-description]").forEach(function (wrapperEl) {
      if (wrapperEl.getAttribute("data-mc-desc-init") === "1") return;
      wrapperEl.setAttribute("data-mc-desc-init", "1");

      var enableToc = toBool(wrapperEl.getAttribute("data-enable-toc"));
      var enableLazy = toBool(wrapperEl.getAttribute("data-enable-lazy"));
      var enableExternal = toBool(wrapperEl.getAttribute("data-enable-external-links"));
      var enableGA4 = toBool(wrapperEl.getAttribute("data-enable-ga4"));

      var relValue = wrapperEl.getAttribute("data-external-rel-base") || "";
      var addNoFollow = toBool(wrapperEl.getAttribute("data-external-nofollow"));

      var contentEl = qs(wrapperEl, "[data-mc-description-rte]");
      if (!contentEl) return;

      convertRteH1ToH2(contentEl);

      if (enableLazy) applyLazyLoading(contentEl);

      if (enableExternal) optimizeExternalLinks(contentEl, relValue, addNoFollow);

      if (enableToc) buildToc(wrapperEl, contentEl);

      if (enableGA4) initGA4LinkTracking(wrapperEl, contentEl, sectionId);

      initBackToTop(wrapperEl);
    });
  }

  /* ---------------------------
     Produktformular: Menge
  ---------------------------- */
  function initProductForm(scopeEl) {
    qsa(scopeEl, "[data-mc-product-form]").forEach(function (form) {
      if (form.getAttribute("data-mc-product-form-init") === "1") return;
      form.setAttribute("data-mc-product-form-init", "1");

      var input = qs(form, "[data-mc-product-quantity]");
      var minus = qs(form, "[data-mc-product-qty-minus]");
      var plus = qs(form, "[data-mc-product-qty-plus]");
      if (!input) return;

      function readNumber(name, fallback) {
        var value = parseInt(input.getAttribute(name) || "", 10);
        return Number.isFinite(value) ? value : fallback;
      }

      function normalize(value) {
        var min = readNumber("min", 1);
        var step = readNumber("step", 1);
        var maxAttr = input.getAttribute("max");
        var max = maxAttr ? parseInt(maxAttr, 10) : null;
        var next = parseInt(value, 10);
        if (!Number.isFinite(next)) next = min;
        next = Math.max(min, next);
        if (Number.isFinite(max)) next = Math.min(max, next);
        if (step > 1) {
          next = min + Math.round((next - min) / step) * step;
          if (Number.isFinite(max)) next = Math.min(max, next);
        }
        input.value = String(next);
        if (minus) minus.disabled = next <= min;
        if (plus && Number.isFinite(max)) plus.disabled = next >= max;
      }

      minus?.addEventListener("click", function () {
        normalize(parseInt(input.value || "1", 10) - readNumber("step", 1));
      });

      plus?.addEventListener("click", function () {
        normalize(parseInt(input.value || "1", 10) + readNumber("step", 1));
      });

      input.addEventListener("change", function () {
        normalize(input.value);
      });

      normalize(input.value);
    });
  }

  /* ---------------------------
     Bootstrap per Scope
  ---------------------------- */
  function initScope(scopeEl) {
    if (!scopeEl || scopeEl.nodeType !== 1) return;

    if (scopeEl.getAttribute("data-mc-initialized") === "1") return;
    scopeEl.setAttribute("data-mc-initialized", "1");

    initH1Relocation(scopeEl);
    initGallery(scopeEl);
    initZoom(scopeEl);
    initDescription(scopeEl);
    initProductForm(scopeEl);
  }

  function initAll() {
    qsa(document, "[data-mc-product-scope]").forEach(initScope);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (evt) {
    var sectionEl = evt && evt.target ? evt.target : null;
    if (!sectionEl) return;

    var scope = qs(sectionEl, "[data-mc-product-scope]");
    if (scope) initScope(scope);
  });

  document.addEventListener("shopify:section:select", function (evt) {
    var sectionEl = evt && evt.target ? evt.target : null;
    if (!sectionEl) return;
    var scope = qs(sectionEl, "[data-mc-product-scope]");
    if (scope) {
      scope.removeAttribute("data-mc-initialized");
      qsa(scope, "[data-mc-description]").forEach(function (w) {
        w.removeAttribute("data-mc-desc-init");
      });
      qsa(scope, ".mc-gallery").forEach(function (g) {
        g.removeAttribute("data-mc-gallery-init");
      });
      initScope(scope);
    }
  });
})();